export default "__VITE_PUBLIC_ASSET__aaff5dc9__"